import { render, staticRenderFns } from "./ClusterRoleBinding.vue?vue&type=template&id=1243758c&"
import script from "./ClusterRoleBinding.vue?vue&type=script&lang=js&"
export * from "./ClusterRoleBinding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports